import React from "react";
import { SITE } from "../config/siteConfig";
import { Layout } from "./Layout";
import { PhoneButton, CallButton } from "./PhoneButtons";
import { CheckIcon, AlertIcon, InfoIcon } from "./icons";
import useSeo from "../utils/seo";

const isEnergy = SITE.key === "energie";

// Contenu commun des pages d'atterrissage : accueil (sans fournisseur) ou page d'une campagne fournisseur.
export function Landing({ provider = null, path = "/" }) {
  const v = SITE.vertical;
  const title = provider ? "Client " + provider.name + " ? " + v.seoTitle : v.seoTitle;
  useSeo({ title, description: v.seoDescription, path: provider ? path : "/" });

  return (
    <Layout provider={provider}>
      <section className="hero">
        <div
          className="hero-bg"
          aria-hidden="true"
          style={{ backgroundImage: "url(/images/hero-conseillere.webp)" }}
        />
        <div className="wrap hero-inner">
          <div className="hero-card">
            <p className="eyebrow">{v.eyebrow}</p>
            <h1>
              {provider ? (
                <>
                  Client {provider.name} ?<br />
                  Comparez les offres {v.product}
                </>
              ) : (
                v.homeTitle
              )}
            </h1>
            <p className="hero-sub">{v.homeSub}</p>
            <PhoneButton phone={SITE.phones.main} label="Comparer avec un conseiller" />
            <p className="price-note">Service de comparaison gratuit · appel au tarif d'un appel local</p>
            <p className="hours-note">Conseillers disponibles {SITE.hours}.</p>
            <ul className="bullets">
              {v.bullets.map((b) => (
                <li key={b}>
                  <i className="bullet-icon">
                    <CheckIcon size={16} />
                  </i>
                  {b}
                </li>
              ))}
            </ul>
            {provider && (
              <div className="brand-notice" role="note">
                <InfoIcon size={20} />
                <p>
                  <strong>{SITE.brandName} n'est pas {provider.name}</strong> et n'agit pas en son nom. Nous sommes un
                  service de comparaison édité par {SITE.company.name} (Barcelone). Pour une question sur votre contrat{" "}
                  {provider.name} (facture, résiliation, réclamation), contactez {provider.name} directement depuis son
                  site officiel :{" "}
                  <a href={"https://" + provider.site} target="_blank" rel="nofollow noopener noreferrer">
                    {provider.site}
                  </a>
                  .
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {isEnergy && (
        <section className="wrap emergency" aria-labelledby="urgences">
          <div className="emergency-box">
            <AlertIcon />
            <div>
              <h2 id="urgences">Panne, coupure ou odeur de gaz ?</h2>
              <p>Nous ne traitons ni les pannes ni les urgences. Contactez directement :</p>
              <ul>
                {SITE.emergency.map((e) => (
                  <li key={e.label}>
                    <strong>{e.label} :</strong> {e.value}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )}

      <section className="wrap savings">
        <h2>{v.savingsTitle}</h2>
        <p>{v.savingsText}</p>
        <img
          src="/images/cliente-telephone.webp"
          alt="Cliente au téléphone avec un conseiller"
          width="96"
          height="96"
          loading="lazy"
          decoding="async"
          className="avatar"
        />
        <CallButton phone={SITE.phones.main} label="Parler à un conseiller" />
      </section>

      <section className="wrap steps" aria-labelledby="comment">
        <h2 id="comment">Comment ça marche ?</h2>
        <ol>
          <li>
            <span className="step-num">1</span>
            <div>
              <h3>Vous appelez</h3>
              <p>Un conseiller de notre partenaire vous répond {SITE.hours}.</p>
            </div>
          </li>
          <li>
            <span className="step-num">2</span>
            <div>
              <h3>Il compare pour vous</h3>
              <p>
                Il étudie votre situation et vous présente les offres {v.product} de nos fournisseurs partenaires.
              </p>
            </div>
          </li>
          <li>
            <span className="step-num">3</span>
            <div>
              <h3>Vous décidez</h3>
              <p>
                Si une offre vous convient, il s'occupe de la souscription avec vous. Vous restez libre de ne rien
                souscrire.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <section className="wrap transparency" aria-labelledby="fonctionnement">
        <h2 id="fonctionnement">Notre fonctionnement</h2>
        <ul>
          <li>
            Le service de comparaison est gratuit. L'appel est facturé au tarif d'un appel local, selon votre
            opérateur.
          </li>
          <li>Les comparaisons ne sont pas exhaustives : elles portent sur une sélection de fournisseurs partenaires.</li>
          <li>
            Les appels sont traités par les conseillers de {v.partner}. Nous sommes rémunérés lorsqu'un contrat est
            souscrit, sans incidence sur le prix que vous payez.
          </li>
          <li>
            {SITE.brandName} n'est{" "}
            {isEnergy
              ? "ni un fournisseur d'énergie ni un gestionnaire de réseau."
              : "ni un fournisseur d'accès à internet ni un opérateur mobile."}
          </li>
        </ul>
        <p className="more">
          Questions fréquentes : <a href="/faq">consulter la FAQ</a> · Qui sommes-nous : <a href="/a-propos">à propos</a>
        </p>
      </section>
    </Layout>
  );
}
